import React from 'react';
import WorldHistory1750ToPresent from '../containers/WorldHistory1750ToPresent';

export default (props) => (
  <WorldHistory1750ToPresent {...props} />
);
